import { isCardQuizCard, isCardSurveyCard } from 'src/model/card'
import { resolveFont } from 'src/utils/workspace-logo'

export const createCourseTemplateAccordion = (
  courseCards,
  landingPageData,
  display,
) => {
  if (!landingPageData) {
    return ''
  }

  // Get localized strings
  const quiz = landingPageData.localizations?.quiz || 'Quiz'
  const feedback = landingPageData.localizations?.feedback || 'Feedback'

  // Process sections and group quiz/survey cards
  const processedSections = courseCards.map(section => {
    const groupedCards = []
    let currentGroup = null

    section.cards.forEach(card => {
      const isQuiz = isCardQuizCard(card.type)
      const isSurvey = isCardSurveyCard(card.type)

      // Check if we should add to current group or create new one
      if (currentGroup && currentGroup.isQuiz && isQuiz) {
        // Add to existing quiz group
        currentGroup.cards.push(card)
      } else if (currentGroup && currentGroup.isSurvey && isSurvey) {
        // Add to existing survey group
        currentGroup.cards.push(card)
      } else {
        // Create new group
        currentGroup = {
          cards: [card],
          isQuiz: isQuiz,
          isSurvey: isSurvey,
        }
        groupedCards.push(currentGroup)
      }
    })

    return {
      ...section,
      groupedCards,
    }
  })

  return `
    <div class="course-container">
      <div class="course-inner-container">
        <div class="course-sections-container">
          ${processedSections
            .map(
              (section, index) => `
            <div class="course-section accordion-section ${
              index === 0 ? 'active' : ''
            }" data-section-id="${index}">
              <div class="section-header accordion-header" onclick="
                const section = this.parentElement;
                const content = section.querySelector('.accordion-content-outline');
                const icon = section.querySelector('.accordion-icon');

                if (section.classList.contains('active')) {
                  section.classList.remove('active');
                  content.style.maxHeight = '0';
                  setTimeout(() => {
                    content.style.display = 'none';
                  }, 300);
                  icon.style.transform = 'rotate(0deg)';
                } else {
                  section.classList.add('active');
                  content.style.display = 'block';
                  setTimeout(() => {
                    content.style.maxHeight = content.scrollHeight + 'px';
                  }, 10);
                  icon.style.transform = 'rotate(180deg)';
                }
              ">

                <div class="section-title">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M2.5 4.6875C2.5 4.43886 2.59877 4.2004 2.77459 4.02459C2.9504 3.84877 3.18886 3.75 3.4375 3.75H12.8125C13.0611 3.75 13.2996 3.84877 13.4754 4.02459C13.6512 4.2004 13.75 4.43886 13.75 4.6875C13.75 4.93614 13.6512 5.1746 13.4754 5.35041C13.2996 5.52623 13.0611 5.625 12.8125 5.625H3.4375C3.18886 5.625 2.9504 5.52623 2.77459 5.35041C2.59877 5.1746 2.5 4.93614 2.5 4.6875ZM2.5 14.6875C2.5 14.4389 2.59877 14.2004 2.77459 14.0246C2.9504 13.8488 3.18886 13.75 3.4375 13.75H11.5625C11.8111 13.75 12.0496 13.8488 12.2254 14.0246C12.4012 14.2004 12.5 14.4389 12.5 14.6875C12.5 14.9361 12.4012 15.1746 12.2254 15.3504C12.0496 15.5262 11.8111 15.625 11.5625 15.625H3.4375C3.18886 15.625 2.9504 15.5262 2.77459 15.3504C2.59877 15.1746 2.5 14.9361 2.5 14.6875ZM3.4375 8.75C3.18886 8.75 2.9504 8.84877 2.77459 9.02459C2.59877 9.2004 2.5 9.43886 2.5 9.6875C2.5 9.93614 2.59877 10.1746 2.77459 10.3504C2.9504 10.5262 3.18886 10.625 3.4375 10.625H16.5625C16.8111 10.625 17.0496 10.5262 17.2254 10.3504C17.4012 10.1746 17.5 9.93614 17.5 9.6875C17.5 9.43886 17.4012 9.2004 17.2254 9.02459C17.0496 8.84877 16.8111 8.75 16.5625 8.75H3.4375Z" fill="#002E47"/>
              </svg>
                  <p>${section.name}</p>
                </div>
                <svg class="accordion-icon" style="transform: rotate(${
                  index === 0 ? '180deg' : '0deg'
                }); transition: transform 0.3s ease;" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z" fill="currentColor"/>
                </svg>
              </div>

              <div class="accordion-content-outline" style="max-height: ${
                index === 0 ? '1000px' : '0'
              }; overflow: hidden; display: ${
                index === 0 ? 'block' : 'none'
              }; transition: max-height 0.3s ease;">

                <div class="cards-container">
                  ${section.groupedCards
                    .map(group => {
                      // Determine the title for the group
                      const groupTitle = group.isQuiz
                        ? quiz
                        : group.isSurvey
                        ? feedback
                        : group.cards[0]?.title || 'Untitled'

                      return `
                    <div class="card-item">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="rgba(145, 158, 171, 0.32)"/>
                      </svg>
                      <div class="card-title">
                         <p> ${groupTitle} </p>
                      </div>
                    </div>
                  `
                    })
                    .join('')}
                </div>
              </div>
            </div>
          `,
            )
            .join('')}
        </div>

        ${
          !display
            ? `
        <div class="start-button-container">
          <div class="start-button" style="background: ${
            landingPageData.primaryColor
          } !important; font-family: ${resolveFont(landingPageData.font)} !important">
            <div class="start-button-text">
              ${
                landingPageData.localizations
                  ? landingPageData.localizations.startButton
                  : 'START COURSE'
              }
            </div>
          </div>
        </div>
        `
            : ''
        }
      </div>
    </div>
  `
}
